export const BETA_FEATURES = {
    hideAddress: {
        label: "HIDE_ADDRESS",
        desc: "Hide Merchant Address in AWB",
    },
    hideLogo: {
        label: "HIDE_LOGO",
        desc: "Hide Parcel Daily logo in AWB",
    },
    hideCodAmount: {
        label: "HIDE_COD_AMOUNT",
        desc: "Hide COD Amount in AWB",
    },
    codWarning: {
        label: "COD_WARNING",
        desc: "Show COD RTO Warning to User",
    },
    shipmentAnalysis: {
        label: "SHIPMENT_ANALYSIS",
        desc: "Show Shipment Analysis page on User Partner",
    },
    autoNDR: {
        label: "AUTO_NEXT_DAY_REMITTANCE",
        desc: "Auto mark all User Order as NDR without charge",
    },
    skipInvoice: {
        label: "SKIP_INVOICE",
        desc: "Skip international order invoice upload",
    },
    nextPageContentList: {
        label: "NEXT_PAGE_CONTENT_LIST",
        desc: "List the order's content list on the next page if character more than 50",
    },
    returnFeeCharge: {
        label: "RETURN_FEE_CHARGE",
        desc: "Mark this user to be charge for Return Handling Fee",
    },
    codWithdrawal: {
        label: "COD_WITHDRAWAL",
        desc: "Enable User to Request Early COD Feature",
    },
    spxPickup: {
        label: "SPX_PICKUP",
        desc: "Mark this user to have pickup option for SPX Express",
    },
    dhlTrackingNumber: {
        label: "DHL_TRACKING_NUMBER",
        desc: "To get Tracking Id instead of Shipment ID for every DHL order",
    },
    skipAPIPrice: {
        label: "SKIP_API_PRICE",
        desc: "When Create Order with API, no need to submit quoted Price (Price will be auto calculated by server).",
    },
    whatsappNotifFull: {
        label: "WHATSAPP_NOTIF_FULL",
        desc: "WhatsApp Pickup Notification to User will include Parcel Content and COD Reminder (if COD)",
    },
    skipCardBinding: {
        label: "SKIP_CARD_BINDING",
        desc: "Allow Credit User to place International Shipment without Credit Card Binding",
    },
    dhlTakeRealWeight: {
        label: "DHL_TAKE_REAL_WEIGHT",
        desc: "For DHL Shipment, take the real weight instead of volumetric weight when applicable. (Choose either one of this or volumetric weight)",
    },
    dhlTakeVolumetricWeight: {
        label: "DHL_TAKE_VOLUMETRIC_WEIGHT",
        desc: "For DHL Shipment, take the volumetric weight instead of real weight when applicable. (Choose either one of this or real weight)",
    },
    capParcelWeight: {
        label: "CAP_PARCEL_WEIGHT",
        desc: "Cap the parcel weight of an SPX order to 10kg when user inputs weight more than 10kg"
    },
    overrideSpxWeight: {
        label: "OVERRIDE_SPX_WEIGHT",
        desc: "Override the parcel weight of an SPX order to 5kg regardless of user input"
    }
}
